import { EOSService } from "../../api/eos-service";
import { PersonelService } from "../../api/personel-service";
import Result from "../../model/result";
import EosUtils from "../../utils/EosUtils";


const initialState = () => {
    return {
        personelDetail: {
            "Perno": "",
            "PersonName": "",
        },
    }
}
const state = initialState()

const getters = {
    getPersonelDetail: (state) => state.personelDetail,
};

const actions = {
    async getPersonDetail({ commit }, { perno }) {
        // debugger
        const response = await PersonelService.getPersonDetail(perno)
        var data = response.data
        if (data.ResponseResultType === 1) {
            if (!EosUtils.isWebKartAdmin()) {
                localStorage.setItem('pswTime',data.Values.PwdLastChangeDate)
                localStorage.setItem('TimeChange',data.Values.TimeChange);
                //save person detail
                commit('setPersonDetail', data.Values);
            }
            return Result.success(data.Values)
        }
        else {
            return Result.error(data.Message)
        }
    },
    async EosPersonelDetail(context, { perno }) {
        return await EOSService.makeRequest(PersonelService.getPersonDetail(perno))
    },
    async GetAbsentPersonelInCondition(state, { params }) {
        var perno = state.rootState.auth.auth.username;
        params.append('adminPerno', perno);

        return await PersonelService.GetAbsentPersonelInCondition(params).then((response) => {
            var data = response.data
            if (data.ResponseResultType === 1) {
                //commit('setPermissionList', data.Values);
                return Result.success(data.Values.Table)
            } else {
                return Result.error(data.Message)
            }
        })
    },
    async GetPersonCalendar(state, perno) {
        var params = new URLSearchParams();
        if (!perno) {
            perno = state.rootState.auth.auth.username;
        }
        params.append('perno', perno);

        return await EOSService.makeRequest(PersonelService.GetPersonCalendar(params))
    },
    async GetPersonFullName(state, { params }) {
        /*let params = new URLSearchParams();
        var perno = state.rootState.auth.auth.username;
        params.append('perno', perno);*/

        return await EOSService.makeRequest(PersonelService.GetPersonFullName(params))
    },
    async getPageWorkflow(state, { params }) {
        return await EOSService.makeRequest(PersonelService.getPageWorkflow(params))
    },
    async GetAccessPersonList(state, { permissionNumber = null }) {
    // async GetAccessPersonList(state,  permissionNumber ) {
        //debugger
        var params = new URLSearchParams();
        var perno = state.rootState.auth.auth.username;
        
        if (permissionNumber) {
            params.append('permissionNumber', permissionNumber);
            params.append('perno', perno);
        }else{
            params.append('adminPerno', perno);
        }
        return await EOSService.makeRequest(PersonelService.GetAccessPersonList(params))
    },
    // async GetAccessPersonList(state, { permissionNumber = null }) {
        async GetAccessPersonListWithParam(state,  permissionNumber ) {
            //debugger
            var params = new URLSearchParams();
            var perno = state.rootState.auth.auth.username;
            
            if (permissionNumber) {
                params.append('permissionNumber', permissionNumber);
                params.append('perno', perno);
            }else{
                params.append('adminPerno', perno);
            }
            return await EOSService.makeRequest(PersonelService.GetAccessPersonList(params))
        },
    async IsFreeOfGroupManager(state) {
        var params = new URLSearchParams();
        var perno = state.rootState.auth.auth.username;
        params.append('Perno', perno);
        return await EOSService.makeRequest(PersonelService.IsFreeOfGroupManager(params))
    },
    async GetPresentPersonel(state, { params }) {
        var perno = state.rootState.auth.auth.username;
        params['adminPerno'] = perno;
        return await EOSService.makeRequest(PersonelService.GetPresentPersonel(params))
    },
    async GetAbsentPersons(state, { params }) {
        var perno = state.rootState.auth.auth.username;
        params['adminPerno'] = perno;
        return await EOSService.makeRequest(PersonelService.GetAbsentPersons(params))
    },
    async GetSectionPersons(state, { params }) {
        var perno = state.rootState.auth.auth.username;
        params['adminPerno'] = perno;
        return await EOSService.makeRequest(PersonelService.GetSectionPersons(params))
    },
    async GetPersonsAttendanceStatus(state, { params }) {
        var perno = state.rootState.auth.auth.username;
        params['adminPerno'] = perno;
        return await EOSService.makeRequest(PersonelService.GetPersonsAttendanceStatus(params))
    },
    async ChangePassword(state, { params }) {
        return await EOSService.makeRequest(PersonelService.ChangePassword(params))
    },
    async ChangePasswordByAdmin(state, { params }) {
        return await EOSService.makeRequest(PersonelService.ChangePasswordByAdmin(params))
    },
    async ChangeAdminPassword(state, { params }) {
        var _params = new URLSearchParams()
        _params.append('password', params.password)
        return await EOSService.makeRequest(PersonelService.ChangeAdminPassword(_params))
    },
    async UpdateDomainUserName(state, { UpdateDomainUserNameParams }) {
        var params = new URLSearchParams()
        params.append('perno', UpdateDomainUserNameParams.perno)
        params.append('domainUsername', UpdateDomainUserNameParams.domainUsername)
        return await EOSService.makeRequest(PersonelService.UpdateDomainUserName(params))
    },
    async FindUserDomainName(state, { perno }) {
        var params = new URLSearchParams()
        params.append('perno', perno);
        return await EOSService.makeRequest(PersonelService.FindUserDomainName(params))
    },
    async getPersonelsSection(state, { pernos }) {
        var params = new URLSearchParams()
        params.append('pernos', pernos);
        return await EOSService.makeRequest(PersonelService.getPersonelsSection(params))
    },
    async EosPerson(state, { perno, sectionCode }) {
        var params = new URLSearchParams()
        params.append('perno', perno);
        params.append('sectionCode', sectionCode);
        return await EOSService.makeRequest(PersonelService.EosPerson(params))
    },
    async GetPernoOfUsername(state, {username}) {
        var params = new URLSearchParams()
        params.append('username', username);
        return await EOSService.makeRequest(PersonelService.GetPernoOfUsername(params))
    },
    async UseActiveDirectory(context) {
        var params = new URLSearchParams()
        var perno = context.rootState.auth.auth.username;
        params.append('perno', perno);
        return await EOSService.makeRequest(PersonelService.UseActiveDirectory(params))
    },
    async ChangeSetting(state, {params}) {
        var _params = new URLSearchParams()
        var perno = state.rootState.auth.auth.username;
        _params.append('perno', perno);
        _params.append('theme', params.theme);
        _params.append('useActiveDirectory', params.useActiveDirectory);
        return await EOSService.makeRequest(PersonelService.ChangeSetting(_params))
    },
};

const mutations = {
    setPersonDetail: (state, personelDetail) =>{ 
        (state.personelDetail = personelDetail)
    },
    resetState(state) {
        Object.assign(state, initialState())
        //console.log('resetState:personel');
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}